import * as Fields from "#root/components/form/fields";
import StandardEditor from "#root/components/standard-editor";
import type { ReactNode } from "react";
import { cloudScheduleTaskCollection } from "#root/schema/platform/cloudschedule";

import PageLayout from "./layout";

export default function ({ taskId: id }): ReactNode {
  return (
    <PageLayout title="CloudSchedule - Edit Task">
      <section>
        <h2>Edit Task</h2>
        <StandardEditor id={id} collection={cloudScheduleTaskCollection}>
          <Fields.Set name="type">
            <label>Task Type</label>
            <Fields.ObjectCode required/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="name">
            <label>Task Name</label>
            <Fields.ProductName required/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="timing">
            <label>Timing Spec</label>
            <Fields.JSONEditor rows={10}/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="input">
            <label>Task Input</label>
            <Fields.JSONEditor rows={10}/>
            <Fields.Validity/>
          </Fields.Set>
        </StandardEditor>
      </section>
    </PageLayout>
  );
}
